<template>
  <div ref="listRef" class="personal-page" @scroll="onScroll">
    <Banner />
    <div
      class="main-container"
      :class="{
        'main-container-fixed': showFixed,
      }"
    >
      <div
        class="mt-[30px]"
        :class="{
          'fixed-pos': showFixed,
        }"
      >
        <div>
          <div class="justify-between content flex-y-center">
            <div class="text-font-50 text-[14px] font-normal">
              <span class="">{{ $t('gong-total-ge', [total]) }}</span>
            </div>
            <div class="flex-y-center">
              <div class="flex-y-center">
                <span class="text-[14px]">
                  {{ $t('geng-xin-shi-jian') }}
                  <a-divider type="vertical" class="mr-[20px]" />
                </span>
                <DictFilter
                  v-model="searchFrom.time"
                  name="updateTime"
                  :has-all="false"
                  class="text-14 gap-x-[20px]"
                />
              </div>
              <div class="flex-y-center ml-[30px]">
                <span class="text-[14px]">
                  {{ $t('ban-shi') }}
                  <a-divider type="vertical" class="mr-[20px]" />
                </span>
                <DictFilter
                  v-model="searchFrom.format"
                  name="formats"
                  class="text-14 gap-x-[20px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-1 wrapper mt-[20px] pt-[5px] -mr-[6px]">
        <TemplateMasonry
          :list="list"
          class="gap-y-[24px]"
          :template_source="TEMPLATE_SOURCE.TEMPLATE_PAGE"
        />
        <div
          v-if="loading"
          class="w-full mt-[20px] flex-center bottom-0 left-0 z-10 bg-back-1 bg-opacity-60"
          :class="{
            'h-[calc(100%-410px)]': pageSize.page === 1,
            fixed: pageSize.page === 1,
          }"
        >
          <a-spin />
        </div>
        <Divider
          v-if="total === list.length && Math.ceil(list.length / PAGE_SIZE) > 1"
        ></Divider>
        <div v-else class="h-[20px]"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { throttle } from 'lodash-es'
import Banner from './Banner.vue'
import TemplateMasonry from '~/components/templates/index.vue'
import { getCompanyInfo, getHomePageOrgTemplate } from '~/api'
import { type CompanyInfoData, type Template } from '~/api/interface'
import { PAGE_SIZE } from '~/constants'

const searchFrom = ref({
  format: 'all',
  time: 'recently',
})

const list = ref<Template[]>([])
// const detail = ref<CompanyInfoData>({
//   name: '',
//   avatar_url: '',
//   background_cover_url: '',
// })
const listRef = ref()
const loading = ref(true)
const route = useRoute()
const pageSize = reactive({
  page: 1,
  page_size: PAGE_SIZE,
})
const total = ref(0)
const showFixed = ref(true)

useBackToTop(() => ({
  scrollContainer: '.personal-page',
  item: '.card-item',
  total: total.value,
}))

const SCROLL_HEIGHT = 300

const getData = async () => {
  loading.value = true

  const params: any = {
    o: '-create_time',
    online_status: 0,
    homepage_org_id: route.params.key,
    ...pageSize,
  }
  if (searchFrom?.value.format !== 'all') {
    params.resolution = searchFrom.value.format
  }

  params.o =
    searchFrom.value.time !== 'recently' ? 'create_time' : '-create_time'
  try {
    const res: any = await getHomePageOrgTemplate({
      ...params,
      template_review_status: 2, // 审核通过
      online_status: 0, // 已上架
    })

    if (!res.code && res.data) {
      total.value = res.data.count
      const arrData = res?.data.results

      for (const item of arrData) {
        const index = list.value.findIndex(
          (record: any) => record.id === item.id
        )
        if (index === -1) {
          list.value.push(item)
        }
      }
    }
    loading.value = false
  } catch (e) {
    console.error(e)

    pageSize.page = pageSize.page - 1
    loading.value = false
  }

  return list.value
}

const onLoadMore = throttle(() => {
  if (total.value > pageSize.page * pageSize.page_size) {
    pageSize.page = pageSize.page + 1
    getData()
  }
}, 2000)

const onScroll = (e: Event) => {
  const { scrollTop, clientHeight, scrollHeight } = e.target as HTMLElement
  // // 滚动到模板处
  // if (scrollTop >= SCROLL_HEIGHT && !showFixed.value) {
  //   showFixed.value = true
  // } else if (scrollTop < SCROLL_HEIGHT) {
  //   showFixed.value = false
  // }

  // 滚动至底部
  if (Math.round(scrollTop + clientHeight) >= scrollHeight - 1) {
    onLoadMore()
  }
}

watch(
  searchFrom.value,
  () => {
    pageSize.page = 1
    list.value = []
    total.value = 0

    nextTick(() => {
      if (listRef.value) {
        listRef.value.scrollTop = 0
      }
    })

    getData()
  },
  {
    immediate: true,
  }
)
</script>

<style lang="scss" scoped>
.personal-page {
  @apply w-full overflow-auto;
  display: block !important;

  .back-to-top.ant-float-btn :deep(.ant-float-btn-icon) {
    @apply text-font-80 w-auto;
  }
  .banner {
    @apply w-full;
    height: 200px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .main-container {
    @apply p-[30px_154px_20px] bg-back-1 flex flex-col;
    height: calc(100vh - 260px);
    margin: 0 auto;

    .fixed-pos {
      @apply sticky bg-back-1 left-0;
      top: 0;
      width: calc(100% + 2px);
      min-width: 1300px;
      padding: 15px 0px 20px;
      z-index: var(--layer-sticky);
    }

    .info {
      @apply flex-y-center justify-between -mt-[95px];
    }
    .logo {
      @apply h-[120px] w-[120px] rounded-full overflow-hidden;
      border: 2px solid rgba(255, 255, 255, 1);
      box-shadow: 0px 12px 20px 0px rgba(105, 98, 255, 0.25);
    }
  }
  .main-container-fixed {
    // height: 100%;
    // position: relative;
    // width: 100%;
    .wrapper {
      margin-top: 50px;
    }
  }
}
</style>
